import React from "react";
import { Input, Select, DatePicker, ConfigProvider } from "antd";
import ptBR from "antd/es/locale/pt_BR";
import dayjs from "dayjs";
import { ComponentInput, ComponentLine } from "../../styled";

const { Search } = Input;

export default function OptionEmpresa({
  dadosCliente,
  listCarteira,
  listEquipe,
  handleChangeCarteira,
  handleChangeEquipe,
  buscarCliente,
  loadingSearch,
  statusInput,
  setstatusInput,
  setdadosCliente,
  isDataEnquadramento,
  formatCNPJ
}) {
  return (
    <>
      {/* Linha 1 */}
      <ComponentLine>
        <ComponentInput>
          <p>Cliente Id</p>
          <Input
            placeholder={
              !dadosCliente.clienteId ? "Cliente ID" : dadosCliente.clienteId
            }
            style={{ width: 240 }}
            disabled
          />
        </ComponentInput>

        <ComponentInput>
          <p>Carteira Cliente</p>
          <Select
            style={{ width: 240 }}
            placeholder={dadosCliente.carteiraCliente}
            value={dadosCliente.carteiraCliente}
            onChange={handleChangeCarteira}
            options={listCarteira.map((carteira) => ({
              value: carteira.id,
              label: carteira.nome,
            }))}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Equipe</p>
          <Select
            style={{ width: 240 }}
            placeholder={"Equipe " + dadosCliente.equipe}
            value={dadosCliente.equipe}
            onChange={handleChangeEquipe}
            options={listEquipe.map((equipe) => ({
              value: equipe.id,
              label: equipe.nome,
            }))}
          />
        </ComponentInput>
      </ComponentLine>

      {/* Linha 2 */}
      <ComponentLine>
        <ComponentInput>
          <p>CNPJ</p>
          <Search
            style={{ width: 240 }}
            placeholder="CNPJ"
            value={formatCNPJ(
              !dadosCliente.cnpjCliente
                ? "CNPJ"
                : dadosCliente.cnpjCliente
            )}
            onSearch={buscarCliente}
            loading={loadingSearch}
            status={statusInput === "cnpjCliente" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, cnpjCliente: value }));
            }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Data Constituição</p>
          <ConfigProvider locale={ptBR}>
            <DatePicker
              style={{ width: 180 }}
              className="date-picker"
              format="DD/MM/YYYY"
              value={
                dadosCliente.dataConstituicao
                  ? dayjs(dadosCliente.dataConstituicao)
                  : null
              }
              status={statusInput === "dataConstituicao" ? "error" : ""}
              onChange={(date) => {
                const value = date ? date.toISOString() : null;
                setstatusInput(value === "" ? "error" : "");
                setdadosCliente((prev) => ({
                  ...prev,
                  dataConstituicao: value,
                }));
              }}
            />
          </ConfigProvider>
        </ComponentInput>

        {isDataEnquadramento && (
          <ComponentInput>
            <p>Data Enquadramento</p>
            <ConfigProvider locale={ptBR}>
              <DatePicker
                style={{ width: 180 }}
                className="date-picker"
                value={
                  dadosCliente.dataReenquadramento
                    ? dayjs(dadosCliente.dataReenquadramento)
                    : null
                }
                onChange={(date) =>
                  setdadosCliente((prev) => ({
                    ...prev,
                    dataReenquadramento: date
                      ? date.toISOString()
                      : null,
                  }))
                }
                format="DD/MM/YYYY"
              />
            </ConfigProvider>
          </ComponentInput>
        )}
      </ComponentLine>

      {/* Linha 3 */}
      <ComponentLine>
        <ComponentInput>
          <p>Razão Social</p>
          <Input
            style={{ width: 760 }}
            placeholder="Razão Social"
            value={dadosCliente.razaoSocial}
            status={statusInput === "razaoSocial" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, razaoSocial: value }));
            }}
          />
        </ComponentInput>
      </ComponentLine>

      {/* Linha 4 */}
      <ComponentLine>
        <ComponentInput>
          <p>Nome Fantasia</p>
          <Input
            style={{ width: 760 }}
            placeholder="Nome Fantasia"
            value={dadosCliente.nomeFantasia}
            status={statusInput === "nomeFantasia" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, nomeFantasia: value }));
            }}
          />
        </ComponentInput>
      </ComponentLine>
    </>
  );
}
